<template>
  <div class="pagination">
    <button class="pageButton" @click="prevPage" :disabled="currentPage === 1">
      Previous
    </button>
    <div
      v-for="page in visiblePages"
      :key="page"
      class="page-number"
      @click="goToPage(page)"
      :class="{ active: currentPage === page }"
    >
      {{ page }}
    </div>
    <button
      class="pageButton"
      @click="nextPage"
      :disabled="currentPage === totalPages"
    >
      Next
    </button>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: Number,
    recordLimit: Number,
    totalCounts: Number
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCounts / this.recordLimit);
    },
    visiblePages() {
       if (this.totalCounts <= 50) {
        return [1];
      }
      const maxVisiblePages = 6; // Maximum number of visible pages
      const pages = [];

      // Always show the first page
      pages.push(1);

      // Determine start and end pages for the visible range
      let startPage, endPage;
      if (this.totalPages <= maxVisiblePages) {
        startPage = 2;
        endPage = this.totalPages - 1;
      } else if (this.currentPage <= Math.ceil(maxVisiblePages / 2)) {
        startPage = 2;
        endPage = maxVisiblePages - 2;
      } else if (this.currentPage >= this.totalPages - Math.floor(maxVisiblePages / 2)) {
        startPage = this.totalPages - maxVisiblePages + 3;
        endPage = this.totalPages - 1;
      } else {
        startPage = this.currentPage - Math.floor(maxVisiblePages / 2);
        endPage = this.currentPage + Math.floor(maxVisiblePages / 2);
      }

      // Add pages to the visible range
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      // Always show the last page
      pages.push(this.totalPages);

      return pages;
    }
  },
  methods: {
    prevPage() {
      if (this.currentPage > 1) {
        this.$emit('prev-page');
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.$emit('next-page');
      }
    },
    goToPage(page) {
      if (page !== this.currentPage) {
        this.$emit('go-to-page', page);
      }
    }
  }
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 14px;
}

.page-number {
  border: 1px solid #06a6e0;
  padding: 3px 7px;
  cursor: pointer;
  margin:0 2px;
  color: #06a6e0;
  border-radius: 3px;
}

.page-number.active {
  font-weight: bold;
  color: #ffff;
  background-color: #06a6e0;


}
.pageButton{
    padding: 5px;
    border-radius: 2px;
    background-color: #06a6e0;
    border: 1px solid #06a6e0;
    color: white;
}
</style>
